import type React from 'react';

function WalleyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 371 371"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Walley Icon</title>

      <g id="Layer_2-2" data-name="Layer 2">
        <g id="Layer_2-2" data-name="Layer 2-2">
          <g id="Layer_1-2" data-name="Layer 1-2">
            <rect width="371" height="371" fill="none" />
          </g>
        </g>
        <path
          d="M295.96,108.86v97.78l-99.22-49.51c-4.25-2.12-9.45-2.12-13.7,0l-99.22,49.51V108.86H5.97c-.34,0-.48,.48-.21,.68l46.08,26.91v97.65c0,9.24,11.44,15.06,20.61,10.48l117.44-58.62,117.44,58.62c9.18,4.59,20.61-1.23,20.61-10.48V108.86h-31.98Z"
          fill="inherit"
        />
      </g>
    </svg>
  );
}

export default WalleyIcon;
